import { getModifierAvailabilityStatus, toModifierAvailability } from './Modifiers.availability';
import { namedOptions, toOptionInput, visibleModifiers } from './Modifiers.formState';

const storedAsInput = stored => ({
  name: stored.core?.name,
  description: stored.core?.description || '',
  ordinal: stored.core?.ordinal,
  isDefault: Boolean(stored.core?.isDefault),
  ...toModifierAvailability(getModifierAvailabilityStatus(stored)),
});

const optionHasChanged = (stored, input) => {
  const current = storedAsInput(stored);
  return Object.keys(input).some(field => current[field] !== input[field]);
};

// Updating a group only writes group-level fields, so the options have to be reconciled one by one.
export const planOptionChanges = (loadedGroup, values) => {
  const unmatched = new Map(visibleModifiers(loadedGroup).map(modifier => [modifier.core?.id, modifier]));
  const created = [];
  const updated = [];

  namedOptions(values).forEach((option, index) => {
    const input = toOptionInput(option, index, values.rules);
    const stored = unmatched.get(option.core?.id);

    if (!stored) {
      created.push({ clientId: option.core?.id, modifier: input });
      return;
    }

    unmatched.delete(option.core.id);
    if (optionHasChanged(stored, input)) updated.push({ modifierId: option.core.id, updates: input });
  });

  return { created, updated, removed: [...unmatched.keys()] };
};

export const planItemLinks = (loadedGroup, values) => {
  const attachedIds = (loadedGroup?.attachedItems || []).map(item => item.itemId);
  const selectedIds = values.itemIds || [];

  return {
    linked: selectedIds.filter(itemId => !attachedIds.includes(itemId)),
    unlinked: attachedIds.filter(itemId => !selectedIds.includes(itemId)),
  };
};
